import React, { useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { getPreviousMonday} from '../helpers/dates'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';



const TopFilter = props => {
  const {activeFiltersNav, setActiveFiltersNav, setOpacity, setPagedItems, datesMenuOther, setDatesMenuOther, activeFilters, setActiveFilters, filterNav, datesMenuStatus, setDatesMenuStatus, language} = useContext(Context);
  const {
    data
  } = props;
  if (typeof data.options == "undefined"){
    return (
      <></>
    )
  }

  const targetElement = document.querySelector('#lock_scroll');

  let open = false;

  let defaultFirstDate = new Date();
  defaultFirstDate.setHours(0,0,0,0);
  defaultFirstDate = new Date(defaultFirstDate.getTime());
  defaultFirstDate = defaultFirstDate.getTime() / 1000;
  let defaultSecondDate = defaultFirstDate + (24 * 60 * 60);

  let defaultFilterDate = new Date();
  defaultFilterDate.setHours(0,0,0,0);

  if ( activeFiltersNav["top_filter"].name == "weekly"){
    if (defaultFilterDate.getDay() !== 1) {
      let previousMonday = getPreviousMonday(defaultFilterDate);
      defaultFilterDate.setTime(previousMonday.getTime());
    }
    defaultFilterDate.setDate(defaultFilterDate.getDate());
    defaultFilterDate.setHours(0,0,0,0);

    defaultFirstDate = defaultFilterDate;
    defaultFirstDate = new Date(defaultFirstDate.getTime());
    defaultFirstDate = defaultFirstDate.getTime() / 1000;

    defaultSecondDate = defaultFirstDate + (7 * 24 * 60 * 60);
  }

  if ( activeFiltersNav["top_filter"].name == "monthly"){
    defaultFilterDate.setDate(1);
    defaultFilterDate.setMonth(defaultFilterDate.getMonth());
    defaultFilterDate.setHours(0,0,0,0);

    defaultFirstDate = defaultFilterDate;
    defaultFirstDate = new Date(defaultFirstDate.getTime());
    defaultFirstDate = defaultFirstDate.getTime() / 1000;

    defaultSecondDate = new Date();
    defaultSecondDate.setDate(1);
    defaultSecondDate.setMonth(defaultSecondDate.getMonth() + 1);
    defaultSecondDate.setHours(0,0,0,0);
    defaultSecondDate = new Date(defaultSecondDate.getTime());
    defaultSecondDate = defaultSecondDate.getTime() / 1000;


  }

  if ( activeFiltersNav["top_filter"].name == "yearly"){
    defaultFilterDate = new Date(defaultFilterDate.getFullYear(), 0, 1);
    defaultFilterDate.setHours(0,0,0,0);

    defaultFirstDate = defaultFilterDate;
    defaultFirstDate = new Date(defaultFirstDate.getTime());
    defaultFirstDate = defaultFirstDate.getTime() / 1000;

    defaultSecondDate = new Date(defaultFilterDate.getFullYear() + 1, 0, 1);
    defaultFilterDate.setHours(0,0,0,0);
    defaultSecondDate = new Date(defaultSecondDate.getTime());
    defaultSecondDate = defaultSecondDate.getTime() / 1000;
  }

  defaultFilterDate = defaultFilterDate.getTime() / 1000



  filterNav.forEach((widget, i) => {
    if (widget.position == "top" && widget.open){
      open = true;
    }
  })


  let options = data.options.filter((option) => {
    return option.value !== "all"
  });

  let total_options = options.length;

  let win_width = window.innerWidth;

  let dir = "vertical";
  if (win_width >= 1024){
    dir = "horizontal";
  }



  function scrollToTop() {
    let container = document.querySelector('.filter-block'),
         pos = container.offsetTop - 52,
         win_width = window.innerWidth;

         if (window.innerWidth < 1024){
           window.scrollTo({
             top: pos,
             left: 0,
             behavior: "smooth",
           });
         }

  }


  const handleClick = (value) => {
    setOpacity(false);
    const filter_nav = {...activeFilters["top_filter"]};
    filter_nav.value = value;


    setActiveFiltersNav({...activeFiltersNav,
      ["top_filter"]: filter_nav
    });

    setTimeout(function(){
      const filter = {...activeFilters["top_filter"]};
      filter.value = value;
      setActiveFilters({...activeFilters,
        ["top_filter"]: filter
      });
    }, 400);

    setDatesMenuStatus(false);

    scrollToTop();
    enableBodyScroll(targetElement);





  }

  const toggleDatesMenu = (value) => {
    setDatesMenuStatus(!datesMenuStatus);
    scrollToTop();
    // if (!datesMenuStatus){
    //   disableBodyScroll(targetElement);
    // } else {
    //   enableBodyScroll(targetElement);
    // }

  }

  const closeDatesMenu = (value) => {
    setDatesMenuStatus(false);
    scrollToTop();
    enableBodyScroll(targetElement);

  }




  return (
    <>
    <div
      id="extra_filters"
      className={classnames('top-filter col-' + total_options, {
        open: open
      })}
    >
    <div
    className={classnames('top-filter-bg  ', {
      active: datesMenuStatus

    })}
    onClick={() => closeDatesMenu()}
    ></div>
      <div className="top-filter-options">
        <div className="top-filter-options-inner">
          {data.choose_text}
        </div>
      </div>
      <div class="top-filter-filters">


      <div
        className={classnames('top-filter-dates ', {
          active: activeFiltersNav["top_filter"].value != data.options[0].value
        })}
       >

       <div
        id="lock_scroll"
        className={classnames('top-filter-dates-bottom ', {
          active: datesMenuStatus
        })}

       >
       <div className="top-filter-dates-bottom-inner">




        <button className="swiper-prev desktop-only">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none">
        <path d="M13.4343 19.4312L5.07263 10.9998L13.4343 2.56834L10.8985 2.21692e-07L-2.47876e-05 10.9998L10.8985 22L13.4343 19.4312Z" fill="white"/>
        <path d="M13.4343 19.4312L5.07263 10.9998L13.4343 2.56834L10.8985 2.21692e-07L-2.47876e-05 10.9998L10.8985 22L13.4343 19.4312Z" stroke="white"/>
        </svg>
        </button>
        <div className="swiper-outer">
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={0}
          grabCursor={true}
          // direction={dir}
          watchOverflow={true}
          navigation={{
              nextEl: '.swiper-next',
              prevEl: '.swiper-prev',
          }}
          freeMode={true}
          preventClicks={false}
          modules={[Keyboard, Scrollbar, Navigation, Pagination]}
          className="mySwiper"
        >

        {options.map((option, i) =>

          <SwiperSlide
            className={classnames('', {
              active: activeFiltersNav["top_filter"].value == option.value
            })}
          >
            <button
              className={classnames('top-filter-item ', {
                active: activeFiltersNav["top_filter"].value == option.value
              })}

              onClick={() => handleClick(option.value)}
            >
              {option.name}
            </button>
          </SwiperSlide>


        )}
        <SwiperSlide
          className={classnames('top-filter-option  ', {
            active: activeFiltersNav["top_filter"].value == data.options[0].value
          })}
        >

            <button
              className={classnames('top-filter-item all ', {
                active: activeFiltersNav["top_filter"].value == data.options[0].value
              })}
              onClick={() => handleClick(data.options[0].value)}
            >
            {data.all_text ? data.all_text : 'All'}
            </button>
        </SwiperSlide>
        </Swiper>
        <div class="swiper-filter-pagination">
          <button className="swiper-prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
              <rect y="50.082" width="50" height="50" transform="rotate(-90 0 50.082)" fill="white"/>
              <path d="M13.2149 31.6329L25 19.8477L36.7851 31.6329" stroke="#E54439" stroke-width="4.58333"/>
            </svg>
          </button>
          <button className="swiper-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
              <rect width="50" height="50" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0.917969)" fill="white"/>
              <path d="M13.2149 19.3671L25 31.1523L36.7851 19.3671" stroke="#E54439" stroke-width="4.58333"/>
            </svg>
          </button>
        </div>

        </div>
        <button className="swiper-next desktop-only">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22" fill="none">
          <path d="M0.594237 19.4312L8.95593 10.9998L0.594238 2.56834L3.1301 2.21692e-07L14.0286 10.9998L3.1301 22L0.594237 19.4312Z" fill="white"/>
          <path d="M0.594237 19.4312L8.95593 10.9998L0.594238 2.56834L3.1301 2.21692e-07L14.0286 10.9998L3.1301 22L0.594237 19.4312Z" stroke="white"/>
          </svg>
        </button>
        </div>

      </div>
      </div>
      </div>



      </div>
    </>
  )
}

export default TopFilter;
